import type { Editor, JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import type { PopoverService } from './popover.service';

/**
 * Regex pattern for popover markers: {{popover:id}}text{{/popover}}
 * Uses [\s\S]*? to match across multiple lines
 */
export const POPOVER_REGEX = /\{\{popover:([^}]+)\}\}([\s\S]*?)\{\{\/popover\}\}/g;
export const POPOVER_ID_DATA_ATTR = 'data-popover-id';

export interface PopoverAttributes {
  id?: string;
  jsonContent: JSONContent;
  linkUrl?: string;
}

export interface EditorWithPopoverService extends Editor {
  storage: Editor['storage'] & {
    popoverService?: PopoverService;
  };
}

export function generatePopoverId(): string {
  return uuid();
}
